const constants = {
  COOKIE : {
    UTM: 'utm',
  },
  STORAGE : {
    FORM_DATA: 'form-data',
    ACCESS_PATH: 'access-path',
  },
  MASTER : {
    OLD_CERT_PERIOD: [
      {period: 3, price: 2500},
      {period: 6, price: 4300},
      {period: 9, price: 6100},
      {period: 12, price: 7900},
      {period: 15, price: 9700},
      {period: 18, price: 11500},
      {period: 21, price: 13300},
      {period: 24, price: 15100},
      {period: 27, price: 16900},
    ],
    CERT_PERIOD: [
      {period: 3, price: 1300},
      {period: 6, price: 2300},
      {period: 9, price: 3300},
      {period: 12, price: 4300},
      {period: 15, price: 5300},
      {period: 18, price: 6300},
      {period: 21, price: 7300},
      {period: 24, price: 8300},
      {period: 27, price: 9300},
    ],
    PREFECTURES: [
      '北海道',
      '青森県',
      '岩手県',
      '宮城県',
      '秋田県',
      '山形県',
      '福島県',
      '茨城県',
      '栃木県',
      '群馬県',
      '埼玉県',
      '千葉県',
      '東京都',
      '神奈川県',
      '新潟県',
      '富山県',
      '石川県',
      '福井県',
      '山梨県',
      '長野県',
      '岐阜県',
      '静岡県',
      '愛知県',
      '三重県',
      '滋賀県',
      '京都府',
      '大阪府',
      '兵庫県',
      '奈良県',
      '和歌山県',
      '鳥取県',
      '島根県',
      '岡山県',
      '広島県',
      '山口県',
      '徳島県',
      '香川県',
      '愛媛県',
      '高知県',
      '福岡県',
      '佐賀県',
      '長崎県',
      '熊本県',
      '大分県',
      '宮崎県',
      '鹿児島県',
      '沖縄県',
    ]
  }
};

export default constants;
